import { render } from "./ShowHighScore.vue?vue&type=template&id=58883528"
import script from "./ShowHighScore.vue?vue&type=script&lang=js"
export * from "./ShowHighScore.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__